import React from 'react';
import { EnvironmentOutlined, DownOutlined } from '@ant-design/icons';

interface MarketOption {
    value: string;
    label: string;
    country: string;
    category: string;
}

const marketOptions: MarketOption[] = [
    { value: 'us-snacking', label: 'US - Snacking', country: 'US', category: 'Snacking' },
    { value: 'us-beverages', label: 'US - Beverages', country: 'US', category: 'Beverages' },
    { value: 'uk-snacking', label: 'UK - Snacking', country: 'UK', category: 'Snacking' },
    { value: 'uk-beverages', label: 'UK - Beverages', country: 'UK', category: 'Beverages' },
    { value: 'ca-snacking', label: 'CA - Snacking', country: 'CA', category: 'Snacking' },
];

interface MarketSelectorProps {
    defaultValue?: string;
    onChange?: (value: string) => void;
    className?: string;
}

const MarketSelector: React.FC<MarketSelectorProps> = ({ defaultValue = 'us-snacking', className = '' }) => {
    const selectedOption = marketOptions.find((option) => option.value === defaultValue) || marketOptions[0];

    return (
        <div
            className={`inline-flex items-center gap-3 px-6 py-3 rounded-full bg-[#F9F3FB] min-w-[200px] min-h-[40px] ${className}`}
        >
            <EnvironmentOutlined className="text-purple-600 text-lg" />
            <span className="text-gray-800 font-medium text-base flex-1">{selectedOption.label}</span>
            <DownOutlined className="text-purple-600 text-sm" />
        </div>
    );
};

export default MarketSelector;
